import type { optionType } from './index.type'
import { MessageBox } from 'element-ui'
import { VideoTemplateType } from '@pt/api/template/index.type'
import type { AssetListItem } from '@/api/public_resource/type'
import type { PublicVideoTemplateItemType } from '@pt/api/template/index.type'
import { AuditStatusType } from '@/views/repository/resource/config/enums'
import { Message } from 'element-ui'

export enum OperationStatus {
  // 删除
  delete = 'delete',
  tags = 'tags',
  audit = 'audit',
  show_status = 'show_status',
}

export const searchOptions: optionType[] = [
  {
    label: '资源名称',
    value: 'name',
  },
  {
    label: '资源id',
    value: 'id',
  },
]

export const typeOptions: optionType[] = [
  {
    label: '多比例模版',
    value: VideoTemplateType.common,
  },
  {
    label: '创意模版',
    value: VideoTemplateType.content,
  },
]

export const isReplaceableOptions: optionType[] = [
  {
    label: '支持',
    value: 1,
  },
  {
    label: '不支持',
    value: 2,
  },
]

export const onlyInnerOptions: optionType[] = [
  {
    label: '是，外部可用',
    value: 2,
  },
  {
    label: '否，仅内部使用',
    value: 1,
  },
]

export const batchBtnOption: optionType[] = [
  {
    label: '删除',
    value: OperationStatus.delete,
  },
  {
    label: '上下架',
    value: OperationStatus.show_status,
  },
  {
    label: '修改标签',
    value: OperationStatus.tags,
  },
  {
    label: '审核通过/审核拒绝',
    value: OperationStatus.audit,
  },
]

export const deleteTemplateConfirm = () => {
  return MessageBox.confirm('此操作不可恢复，请确认。', '确定删除视频模版吗?', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    customClass: 'pt-custom-confirm-message',
    dangerouslyUseHTMLString: true,
    type: 'warning',
  })
}

// 已上架模版不支持删除
export const noSupportedDelete = (
  checkedRow: AssetListItem[] | PublicVideoTemplateItemType[],
) => {
  if (checkedRow.some((s) => s.show_status === 2)) {
    return Message.error('已上架模版不支持删除')
  }
}

// 待审核和渲染失败才能审核操作
export const noSupportedAudit = (
  checkedRow: AssetListItem[] | PublicVideoTemplateItemType[],
) => {
  if (
    checkedRow.some((s) =>
      [AuditStatusType.edit, AuditStatusType.review].includes(
        s.audit_status as AuditStatusType,
      ),
    )
  ) {
    return Message.error('编辑中、渲染中的模版不支持审核操作')
  }
}

// 多比例模版不支持修改标签
export const noSupportedEditTags = (
  checkedRow: PublicVideoTemplateItemType[],
) => {
  if (checkedRow.some((s) => s.type === VideoTemplateType.common)) {
    return Message.error('多比例模版不支持修改标签')
  }
}
